import { render, staticRenderFns } from "./releaseprozess-icons.vue?vue&type=template&id=2de65112"
import script from "./releaseprozess-icons.vue?vue&type=script&lang=js"
export * from "./releaseprozess-icons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports